class componentHelper {
  static isset (slot, object) {
    return typeof slot[object] !== 'undefined' && slot[object].length > 0
  }
}

export default componentHelper
